module.exports = __webpack_public_path__ + "img/Solvay.ee2289fc.png";